// assets
import { IconReport } from '@tabler/icons';
import admChild from './AdmChild';

// constant
const icons = { IconReport };

const adminCol = {
    id: `adminCol-${Math.random()}`,
    title: 'Admin',
    type: 'collapse',
    // url: `/dashboard/default`,
    icon: icons.IconReport,
    breadcrumbs: false,
    children: admChild,
    role: process.env.REACT_APP_RL_ADMCOL
};

export default adminCol;